import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { FormlyModule } from '@ngx-formly/core';

import { ISPUIInputModule } from '@ispui/ng-input';
import { ISPUILinkModule } from '@ispui/ng-link';
import { ISPUITooltipModule } from '@ispui/ng-tooltip';

import { SvgIconModule } from 'common/svg-icon-module/svg-icon.module';

import { PasswordFieldComponent } from './password.component';

import { ISPFieldType } from '../../model';

/**
 * Formly's input field component
 */
@NgModule({
  declarations: [PasswordFieldComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormlyModule.forChild({
      types: [
        {
          name: ISPFieldType.Password,
          component: PasswordFieldComponent,
        },
      ],
    }),
    ISPUILinkModule,
    ISPUIInputModule,
    SvgIconModule,
    ISPUITooltipModule,
  ],
})
export class PasswordFieldModule {}
